"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[690],{

/***/ 47255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ BottomSheet; },
  "I": function() { return /* reexport */ ErrorDialog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@reach/dialog/styles.css
var styles = __webpack_require__(44600);
// EXTERNAL MODULE: ./node_modules/@reach/dialog/dist/dialog.esm.js + 53 modules
var dialog_esm = __webpack_require__(73251);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.js + 22 modules
var motion_minimal = __webpack_require__(48786);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMedia.js + 1 modules
var useMedia = __webpack_require__(58828);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/chime-ui/components/Icons/index.tsx
var Icons = __webpack_require__(92061);
// EXTERNAL MODULE: ./src/chime-ui/system/index.ts
var system = __webpack_require__(68526);
// EXTERNAL MODULE: ./src/chime-ui/system/media.ts
var media = __webpack_require__(68574);
// EXTERNAL MODULE: ./src/chime-ui/components/Button/index.tsx
var Button = __webpack_require__(29947);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/chime-ui/components/Modal/BottomSheet.tsx



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var useBottomSheet = function useBottomSheet() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$onShow = _ref.onShow,
      onShow = _ref$onShow === void 0 ? function () {
    return undefined;
  } : _ref$onShow,
      _ref$onDismiss = _ref.onDismiss,
      onDismiss = _ref$onDismiss === void 0 ? function () {
    return undefined;
  } : _ref$onDismiss;

  var _useState = (0,react.useState)(false),
      isShowing = _useState[0],
      setIsShowing = _useState[1];

  var handleShow = (0,react.useCallback)(function () {
    setIsShowing(true);
    onShow();
  }, [onShow]);
  var handleDismiss = (0,react.useCallback)(function () {
    setIsShowing(false);
    onDismiss();
  }, [onDismiss]);

  function Modal(_ref2) {
    var children = _ref2.children,
        _ref2$showX = _ref2.showX,
        showX = _ref2$showX === void 0 ? false : _ref2$showX,
        handleDismiss = _ref2.handleDismiss,
        _ref2$dismissText = _ref2.dismissText,
        dismissText = _ref2$dismissText === void 0 ? 'Got it' : _ref2$dismissText;
    var isTablet = (0,useMedia/* default */.Z)("(min-width: ".concat(media/* screenSizes.tablet */.f.tablet, "px)"));
    var shouldShowX = isTablet || showX;
    var contentAnimationProps = isTablet ? {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      }
    } : {
      initial: {
        y: '100%'
      },
      animate: {
        y: 0
      },
      exit: {
        y: '100%'
      }
    };
    var MotionDialogOverlay = (0,motion_minimal.m)(StyledDialogOverlay, {
      forwardMotionProps: true
    });
    var MotionDialogContent = (0,motion_minimal.m)(StyledDialogContent, {
      forwardMotionProps: true
    });
    return /*#__PURE__*/(0,jsx_runtime.jsx)(MotionDialogOverlay, {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      },
      transition: {
        type: 'easeIn',
        delay: system/* values.TIMEOUT_DELAY */.VO.TIMEOUT_DELAY
      },
      onDismiss: handleDismiss,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(MotionDialogContent, _objectSpread(_objectSpread({
        "aria-label": "Info Modal",
        transition: {
          type: 'easeIn',
          delay: system/* values.TIMEOUT_DELAY */.VO.TIMEOUT_DELAY
        }
      }, contentAnimationProps), {}, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Message, {
          children: [shouldShowX && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIconButton, {
            onClick: handleDismiss
          }), children]
        }), !isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* SecondaryButton */.kq, {
          onClick: handleDismiss,
          children: dismissText
        })]
      }))
    });
  }

  return {
    Modal: Modal,
    isShowing: isShowing,
    handleShow: handleShow,
    handleDismiss: handleDismiss
  };
};

/* harmony default export */ var BottomSheet = (useBottomSheet);
var CloseIconButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* GhostButton */.gh).attrs(function () {
  return {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* CloseIcon */.Tw, {})
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 0;\n  right: 0;\n"])));
var StyledDialogOverlay = (0,styled_components_browser_esm/* default */.ZP)(dialog_esm/* DialogOverlay */.t9)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: hsla(0, 0%, 0%, 0.6);\n  z-index: 1;\n"])));
var StyledDialogContent = (0,styled_components_browser_esm/* default */.ZP)(dialog_esm/* DialogContent */.cZ)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  background: ", ";\n  position: fixed;\n  padding: 1.5rem;\n  display: block;\n  max-height: 80vh;\n  overflow: auto;\n  margin: 0;\n  width: auto;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.fonts.primaryFont;
}, function (props) {
  return props.theme.colors.white;
}, media/* default.mobileOnly */.Z.mobileOnly(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    left: 0;\n    right: 0;\n    bottom: 0;\n    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);\n    border-radius: 0.5rem 0.5rem 0 0;\n  "]))), media/* default.tablet */.Z.tablet(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n    top: 9.75rem;\n    width: 37.5rem;\n    border-radius: 0.5rem;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);\n  "]))));
var Message = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  margin: 0;\n  span {\n    white-space: pre-wrap;\n  }\n"])));
// EXTERNAL MODULE: ./node_modules/react-use/esm/useTimeoutFn.js
var useTimeoutFn = __webpack_require__(34513);
// EXTERNAL MODULE: ./src/chime-ui/components/Typography/index.tsx
var Typography = __webpack_require__(50152);
;// CONCATENATED MODULE: ./src/chime-ui/components/Modal/ErrorDialog.tsx


var ErrorDialog_templateObject, ErrorDialog_templateObject2, ErrorDialog_templateObject3, ErrorDialog_templateObject4, ErrorDialog_templateObject5;













var useErrorAlert = function useErrorAlert() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onShow = _ref.onShow,
      onDismiss = _ref.onDismiss;

  var _useState = (0,react.useState)(false),
      isShowing = _useState[0],
      setIsShowing = _useState[1];

  var handleShow = (0,react.useCallback)(function () {
    setIsShowing(true);

    if (typeof onShow === 'function') {
      onShow();
    }
  }, [onShow]);
  var handleDismiss = (0,react.useCallback)(function () {
    setIsShowing(false);

    if (typeof onDismiss === 'function') {
      onDismiss();
    }
  }, [onDismiss]);
  var MotionDialogContent = (0,motion_minimal.m)(ErrorDialog_StyledDialogContent, {
    forwardMotionProps: true
  });

  function Modal(_ref2) {
    var children = _ref2.children;
    (0,useTimeoutFn/* default */.Z)(function () {
      handleDismiss();
    }, system/* values.MESSAGE_TIMEOUT */.VO.MESSAGE_TIMEOUT);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorDialog_StyledDialogOverlay, {
      dangerouslyBypassFocusLock: true,
      dangerouslyBypassScrollLock: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MotionDialogContent, {
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        },
        transition: {
          type: 'easeIn',
          delay: system/* values.TIMEOUT_DELAY */.VO.TIMEOUT_DELAY
        },
        "aria-label": "Error Dialog",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorDialog_Message, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* StandardText */.nn, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* WarningIcon */.aN, {}), children]
          })
        })
      })
    });
  }

  return {
    Modal: Modal,
    isShowing: isShowing,
    handleShow: handleShow,
    handleDismiss: handleDismiss
  };
};

/* harmony default export */ var ErrorDialog = (useErrorAlert);
var ErrorDialog_StyledDialogOverlay = (0,styled_components_browser_esm/* default */.ZP)(dialog_esm/* DialogOverlay */.t9)(ErrorDialog_templateObject || (ErrorDialog_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background: none;\n  bottom: 75%;\n"])));
var ErrorDialog_StyledDialogContent = (0,styled_components_browser_esm/* default */.ZP)(dialog_esm/* DialogContent */.cZ)(ErrorDialog_templateObject2 || (ErrorDialog_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-family: ", ";\n  background: ", ";\n  position: fixed;\n  padding: 0.5rem 1rem;\n  background: ", ";\n  display: block;\n  border-radius: 0.5rem;\n  width: auto;\n  margin: 0;\n\n  ", "\n\n  ", "\n"])), function (props) {
  return props.theme.fonts.primaryFont;
}, function (props) {
  return props.theme.colors.white;
}, system/* colors.tint.alertRed.a10 */.O9.tint.alertRed.a10, media/* default.mobileOnly */.Z.mobileOnly(ErrorDialog_templateObject3 || (ErrorDialog_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    top: 1rem;\n    left: 1.5rem;\n    right: 1.5rem;\n  "]))), media/* default.tablet */.Z.tablet(ErrorDialog_templateObject4 || (ErrorDialog_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    top: 5.75rem;\n    width: 32.5rem;\n    left: 50%;\n    transform: translateX(-50%);\n  "]))));
var ErrorDialog_Message = styled_components_browser_esm/* default.div */.ZP.div(ErrorDialog_templateObject5 || (ErrorDialog_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n  margin: 0;\n  span {\n    white-space: pre-wrap;\n  }\n"])));
;// CONCATENATED MODULE: ./src/chime-ui/components/Modal/index.tsx



/***/ }),

/***/ 4850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/chime-ui/system/index.ts
var system = __webpack_require__(68526);
;// CONCATENATED MODULE: ./src/chime-ui/components/Spinner/Spinner.tsx


var _templateObject, _templateObject2;



var rotate360 = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Spinner = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
  role: 'alert',
  'aria-live': 'assertive'
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 50%;\n  width: 2.5rem;\n  height: 2.5rem;\n  margin: 0 auto;\n  border-radius: 100%;\n  border: 4px solid rgba(102, 102, 102, 0.5);\n  border-left-color: ", ";\n  border-top-color: ", ";\n  animation: ", " 2s linear infinite;\n"])), system/* colors.darkGreen */.O9.darkGreen, system/* colors.darkGreen */.O9.darkGreen, rotate360);
/* harmony default export */ var Spinner_Spinner = (Spinner);
;// CONCATENATED MODULE: ./src/chime-ui/components/Spinner/index.tsx


/***/ }),

/***/ 92390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17674);
/* harmony import */ var components_SubPages_Confirmation_useCreateConfirmationPageHook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72736);
/* harmony import */ var hooks_useUserContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36220);
/* harmony import */ var utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79233);





function usePayAnyoneConfirmationPage() {
  var _useUserContext = (0,hooks_useUserContext__WEBPACK_IMPORTED_MODULE_1__/* .useUserContext */ .S)(),
      _useUserContext2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId;

  var trackPageViewed = function trackPageViewed() {
    return (0,utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .trackPayAnyoneConfirmationInfoPageViewed */ .Vz)(publicId);
  };

  var trackCtaClick = function trackCtaClick() {
    return (0,utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .trackCTATapped */ .u)('Pay Anyone', 'Join Chime', 'Pay Anyone Confirmation Page', 'pay_anyone_confirmation_join_chime_button', publicId);
  }; // Fire segment event for Google Play Store CTA Tapped


  var onGooglePlayCTAClick = function onGooglePlayCTAClick() {
    (0,utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .trackCTATapped */ .u)('Pay Anyone', 'Google Play Store CTA', 'Pay Anyone Confirmation Page', 'pay_anyone_confirmation_download_google_play_button', publicId);
    location.href = 'https://play.google.com/store/apps/details?id=com.onedebit.chime&hl=en_US&gl=US&pli=1';
  }; // Fire segment event for iOS App Store CTA Tapped


  var oniOSAppStoreCTAClick = function oniOSAppStoreCTAClick() {
    (0,utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .trackCTATapped */ .u)('Pay Anyone', 'iOS App Store CTA', 'Pay Anyone Confirmation Page', 'pay_anyone_confirmation_download_iOS_app_button', publicId);
    location.href = 'https://apps.apple.com/us/app/chime-mobile-banking/id836215269';
  };

  var _useCreateConfirmatio = (0,components_SubPages_Confirmation_useCreateConfirmationPageHook__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(trackPageViewed, trackCtaClick),
      trackCtaButtonClick = _useCreateConfirmatio.trackCtaButtonClick;

  return {
    trackCtaButtonClick: trackCtaButtonClick,
    oniOSAppStoreCTAClick: oniOSAppStoreCTAClick,
    onGooglePlayCTAClick: onGooglePlayCTAClick
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (usePayAnyoneConfirmationPage);

/***/ }),

/***/ 53996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(71383);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66473);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(19521);
/* harmony import */ var chime_ui_components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29947);
/* harmony import */ var chime_ui_components_Icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92061);
/* harmony import */ var chime_ui_components_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47255);
/* harmony import */ var chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50152);
/* harmony import */ var chime_ui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68526);
/* harmony import */ var chime_ui_system_media__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68574);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23991);
/* harmony import */ var components_Layout_Header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45651);
/* harmony import */ var components_SubPages_Confirmation_Pay_usePayAnyoneConfirmationPage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92390);
/* harmony import */ var hooks_useP2PEnrollmentFlow__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56785);
/* harmony import */ var hooks_useUserContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36220);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;


















function ConfirmationWithoutBonus() {
  var _usePayAnyoneConfirma = (0,components_SubPages_Confirmation_Pay_usePayAnyoneConfirmationPage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(),
      trackCtaButtonClick = _usePayAnyoneConfirma.trackCtaButtonClick;

  var _useUserContext = (0,hooks_useUserContext__WEBPACK_IMPORTED_MODULE_11__/* .useUserContext */ .S)(),
      _useUserContext2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var amount = userData.amount;

  var _useP2PEnrollmentFlow = (0,hooks_useP2PEnrollmentFlow__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(false),
      activateP2pEnrollmentAndNavigate = _useP2PEnrollmentFlow.activateP2pEnrollmentAndNavigate;

  var _useBottomSheet = (0,chime_ui_components_Modal__WEBPACK_IMPORTED_MODULE_3__/* .useBottomSheet */ .a)(),
      Modal = _useBottomSheet.Modal;

  var _useBottomSheet2 = (0,chime_ui_components_Modal__WEBPACK_IMPORTED_MODULE_3__/* .useBottomSheet */ .a)(),
      isDirectDepositModalShowing = _useBottomSheet2.isShowing,
      showDirectDepositModal = _useBottomSheet2.handleShow,
      dismissDirectDepositModal = _useBottomSheet2.handleDismiss;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
    header: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_Layout_Header__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_7__/* .ContentWrapper */ .vs, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(ImageLayout, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("img", {
          src: "".concat(chime_ui_components_Icons__WEBPACK_IMPORTED_MODULE_2__/* .iconsPath */ .VA, "confirmationPageMessage.svg"),
          alt: "Money's on the way"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(ContentLayout, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx, {
          size: 'medium',
          children: ["Cha-ching!", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
            color: chime_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .colors.darkGreen */ .O9.darkGreen,
            children: ["$", amount]
          }), " is coming!"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
          size: 'standard',
          children: ["Get even more from Chime like getting paid up to 2 days early with direct deposit ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(chime_ui_components_Button__WEBPACK_IMPORTED_MODULE_1__/* .UnderlinedGhostButton */ .nz, {
            onClick: showDirectDepositModal,
            children: "See details"
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(ButtonLayout, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(chime_ui_components_Button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
          onClick: function onClick() {
            return activateP2pEnrollmentAndNavigate(trackCtaButtonClick);
          },
          children: "Join Chime"
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_14__/* .AnimatePresence */ .M, {
      children: isDirectDepositModalShowing && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(Modal, {
        showX: true,
        handleDismiss: dismissDirectDepositModal,
        dismissText: 'Dismiss',
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(ModalContent, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(ModalText, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .xv, {
              size: 'standard',
              children: "Early access to direct deposit funds depends on the timing of the submission of the payment file from the payer. We generally make these funds available on the day the payment file is received, which may be up to 2 days earlier than the scheduled payment date."
            })
          })
        })
      })
    })]
  });
}

var ModalContent = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n  padding-top: 2.5rem;\n"])));
var ButtonLayout = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject2 || (_templateObject2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n  ", ";\n\n  background-color: ", ";\n  padding: 1.5rem 0;\n  margin: 1rem 1.5rem 0 1.5rem;\n  border-top: 1px solid ", ";\n"])), chime_ui_system_media__WEBPACK_IMPORTED_MODULE_6__/* ["default"].mobileOnly */ .Z.mobileOnly(_templateObject3 || (_templateObject3 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    left: 0;\n  "]))), chime_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .colors.white */ .O9.white, chime_ui_system__WEBPACK_IMPORTED_MODULE_5__/* .colors.lightGrey */ .O9.lightGrey);
var ModalText = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject4 || (_templateObject4 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n  margin-bottom: 2rem;\n"])));
var ContentLayout = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject5 || (_templateObject5 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 1.5rem;\n"])));
var ImageLayout = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(["\n  display: flex;\n  justify-content: center;\n"])));
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmationWithoutBonus);

/***/ }),

/***/ 43218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* reexport */ Pay_PayAnyoneConfirmation; },
  "C": function() { return /* reexport */ Request_ReceiveFromAnyoneConfirmation; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/use-animation.js + 1 modules
var use_animation = __webpack_require__(18638);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.js + 22 modules
var motion_minimal = __webpack_require__(48786);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/chime-ui/components/Button/index.tsx
var Button = __webpack_require__(29947);
// EXTERNAL MODULE: ./src/chime-ui/components/Icons/index.tsx
var Icons = __webpack_require__(92061);
// EXTERNAL MODULE: ./src/chime-ui/components/Typography/index.tsx
var Typography = __webpack_require__(50152);
// EXTERNAL MODULE: ./src/chime-ui/system/index.ts
var system = __webpack_require__(68526);
// EXTERNAL MODULE: ./src/chime-ui/system/media.ts
var media = __webpack_require__(68574);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx
var Layout = __webpack_require__(23991);
// EXTERNAL MODULE: ./src/components/Layout/Header.tsx
var Header = __webpack_require__(45651);
;// CONCATENATED MODULE: ./src/components/SubPages/Confirmation/Confirmation.animations.ts
var iconAnimations = {
  hidden: {
    opacity: 0
  },
  showTitle: {
    opacity: 0
  },
  showIcon: {
    opacity: [0, 1, 1],
    y: [100, 70, 70],
    rotate: [0, 0, 0, 5, -5, 5, -5, 5, 0],
    transition: {
      duration: 1,
      times: [0, 0.1, 0.15, 0.5, 0.6, 0.7, 1],
      ease: 'easeInOut'
    }
  },
  contentSlide: {
    opacity: [1, 0],
    duration: 0.3
  }
};
var titleAnimations = {
  hidden: {
    opacity: 0
  },
  showTitle: {
    opacity: [0, 1],
    y: [200, 150],
    transition: {
      duration: 0.5
    }
  },
  contentSlide: {
    y: [150, 0],
    transition: {
      duration: 0.8,
      times: [0, 0.1, 0.15, 0.5, 0.6, 0.7, 1],
      ease: 'easeInOut'
    }
  }
};
var contentAnimations = {
  hidden: {
    opacity: 0
  },
  showTitle: {
    opacity: 0
  },
  showIcon: {
    opacity: 0
  },
  contentSlide: {
    opacity: [0, 1],
    y: [140, 0]
  }
};
// EXTERNAL MODULE: ./src/hooks/useBonusAmount.tsx
var useBonusAmount = __webpack_require__(42029);
// EXTERNAL MODULE: ./src/hooks/useIntersect.ts
var useIntersect = __webpack_require__(62463);
// EXTERNAL MODULE: ./src/hooks/useP2PEnrollmentFlow.tsx
var useP2PEnrollmentFlow = __webpack_require__(56785);
// EXTERNAL MODULE: ./src/hooks/useUserContext.tsx
var useUserContext = __webpack_require__(36220);
// EXTERNAL MODULE: ./src/hooks/useValuePropsSegmentEvents.ts
var useValuePropsSegmentEvents = __webpack_require__(9502);
// EXTERNAL MODULE: ./src/components/SubPages/Confirmation/features/successPageMessaging/ConfirmationWithoutBonus.tsx
var ConfirmationWithoutBonus = __webpack_require__(53996);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.js + 6 modules
var AnimatePresence = __webpack_require__(66473);
// EXTERNAL MODULE: ./src/chime-ui/components/Modal/index.tsx + 2 modules
var Modal = __webpack_require__(47255);
// EXTERNAL MODULE: ./src/components/SubPages/Landing/PayFAQText.tsx
var PayFAQText = __webpack_require__(44143);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SubPages/Confirmation/Pay/ConfirmationTermsAndConditionsValueProps.tsx


var _templateObject, _templateObject2;












function ConfirmationTermsAndConditionsValueProps(_ref) {
  var bank = _ref.bank;

  var _useBottomSheet = (0,Modal/* useBottomSheet */.a)(),
      FAQModal = _useBottomSheet.Modal,
      faqIsShowing = _useBottomSheet.isShowing,
      dismissFAQModal = _useBottomSheet.handleDismiss,
      showFAQModal = _useBottomSheet.handleShow;

  var _useBonusAmount = (0,useBonusAmount/* useBonusAmount */.O)(),
      bonusAmount = _useBonusAmount.bonusAmount;

  var handleFAQClick = function handleFAQClick() {
    showFAQModal();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ConfirmationTermsAndConditionsValueProps_Layout, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
      size: 'small',
      color: system/* colors.darkGrey */.O9.darkGrey,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
        children: "1"
      }), ' ', bank === 'bancorp' ? 'Banking services provided by The Bancorp Bank, Member FDIC' : bank === 'stride' ? 'Banking services provided by Stride Bank N.A., Member FDIC' : '', ". Sometimes instant transfers can be delayed. See the", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* UnderlinedBoldGhostButton */.Ni, {
        onClick: handleFAQClick,
        children: "Instant Transfers FAQs"
      }), ' ', "for full details."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
      size: 'small',
      color: system/* colors.darkGrey */.O9.darkGrey,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
        children: "2"
      }), " Deposits in Chime accounts are FDIC insured through The Bancorp Bank or Stride Bank; Members FDIC."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
      size: 'small',
      color: system/* colors.darkGrey */.O9.darkGrey,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
        children: "\u2020"
      }), "Terms and Conditions: In order to qualify for and receive the $", bonusAmount, " reward for claiming a fee-free transfer with Chime, the following conditions must be met: you must (1) be part of the \u201CClaim with Chime\u201D campaign; (2) have received a Pay Anyone transfer from a Chime member; (3) not have previously opened a Chime Checking Account (\u201CAccount\u201D); (4) open the new Account as prompted by this webpage to claim your Pay Anyone transfer; and (5) have activated your physical Chime Visa Debit Card within fourteen (14) days of opening an Account. Please note, if you open an Account independently from the prompt on this webpage, you will not be eligible for the reward. Pay Anyone transfers expire after fourteen (14) days. If your Pay Anyone transfer expires before you open an Account, you will not be eligible for the reward. The reward will be deposited into your new Checking Account generally within two (2) business days after the above conditions are met. Limit 1 reward per individual. Chime reserves the right to cancel or modify the terms of this reward offer or terminate eligibility at any time with or without prior notice. Credits of $10 or more will be reported on tax form 1099-INT for new member. Banking services are provided by The Bancorp Bank or Stride Bank, N.A., Members FDIC."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
      children: faqIsShowing && /*#__PURE__*/(0,jsx_runtime.jsxs)(FAQModal, {
        handleDismiss: dismissFAQModal,
        showX: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalTitle, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Title */.Dx, {
            size: 'small',
            children: "Pay Friends Instant Transfer FAQ For Non-Chime Members"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PayFAQText/* default */.Z, {})]
      })
    })]
  });
}

var ConfirmationTermsAndConditionsValueProps_Layout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 1.5rem;\n  text-align: left;\n"])));
var ModalTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-right: 1.5rem;\n  min-height: 1.75rem;\n  margin-bottom: 0.5rem;\n"])));
/* harmony default export */ var Pay_ConfirmationTermsAndConditionsValueProps = (ConfirmationTermsAndConditionsValueProps);
// EXTERNAL MODULE: ./src/components/SubPages/Confirmation/Pay/usePayAnyoneConfirmationPage.tsx
var usePayAnyoneConfirmationPage = __webpack_require__(92390);
;// CONCATENATED MODULE: ./src/components/SubPages/Confirmation/Pay/PayAnyoneConfirmation.tsx




var PayAnyoneConfirmation_templateObject, PayAnyoneConfirmation_templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
























var PayAnyoneConfirmation = function PayAnyoneConfirmation() {
  var containerRef = (0,react.useRef)(null);

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var _useBonusAmount = (0,useBonusAmount/* useBonusAmount */.O)(),
      bonusAmount = _useBonusAmount.bonusAmount;

  var isClaimWithChimeEnabled = userData.claimWithChime,
      amount = userData.amount,
      bank = userData.bank,
      name = userData.name;

  var _usePayAnyoneConfirma = (0,usePayAnyoneConfirmationPage/* default */.Z)(),
      trackCtaButtonClick = _usePayAnyoneConfirma.trackCtaButtonClick;

  var _useP2PEnrollmentFlow = (0,useP2PEnrollmentFlow/* default */.Z)(isClaimWithChimeEnabled, null),
      activateP2pEnrollmentAndNavigate = _useP2PEnrollmentFlow.activateP2pEnrollmentAndNavigate;

  var animationControls = (0,use_animation/* useAnimation */._)();
  (0,react.useEffect)(function () {
    var startAnimation = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return animationControls.start('showTitle');

              case 2:
                _context.next = 4;
                return animationControls.start('showIcon');

              case 4:
                _context.next = 6;
                return animationControls.start('contentSlide');

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function startAnimation() {
        return _ref.apply(this, arguments);
      };
    }();

    startAnimation();
  }, [animationControls]);

  var _useIntersect = (0,useIntersect/* useIntersect */.U)({
    root: null,
    rootMargin: '0px',
    threshold: [0.5, 0.9]
  }),
      _useIntersect2 = (0,slicedToArray/* default */.Z)(_useIntersect, 2),
      setNode = _useIntersect2[0],
      entry = _useIntersect2[1];

  (0,react.useEffect)(function () {
    setNode(containerRef.current);
  }, [setNode]);
  (0,useValuePropsSegmentEvents/* useValuePropsSegmentEvents */.h)(entry, 'PayAnyone Confirmation Page'); // TODO: Remove conditional render once migration is complete: https://chime.atlassian.net/browse/PFG-854

  if (!isClaimWithChimeEnabled) return /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmationWithoutBonus/* default */.Z, {});
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.ZP, {
    header: /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}),
    footer: /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatedFooter, {
      bank: bank,
      animationControls: animationControls
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MoneyIconLayout, {
      initial: 'hidden',
      animate: animationControls,
      variants: iconAnimations,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* MoneyBox */.j6, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TitleLayout, {
      initial: 'hidden',
      animate: animationControls,
      variants: titleAnimations,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Title */.Dx, {
        size: 'small',
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
          color: system/* colors.darkGreen */.O9.darkGreen,
          children: ["$", amount]
        }), " is coming!", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Want another $", bonusAmount, "?"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(motion_minimal.m.div, {
      initial: 'hidden',
      animate: animationControls,
      variants: contentAnimations,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Separator, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ContentLayout, {
        ref: containerRef,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ValuePropsLayout, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ValuePropsTitle, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* StrongText */.aF, {
              children: ["Join ", name, " on Chime to get", ' ', /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
                color: system/* colors.darkGreen */.O9.darkGreen,
                children: ["another $", bonusAmount]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
                children: "*"
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(Icons/* iconsPath */.VA, "payRequestIconSmall.svg"),
              alt: "Paid up to 2 days early with direct deposit"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
              children: "Pay Anyone fee-free, no matter what bank account they use"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(Icons/* iconsPath */.VA, "cashOut.svg"),
              alt: "Fee-free overdraft up to $200"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
              children: ["Cash-out instantly", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
                children: "1"
              }), " with no fees"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(Icons/* iconsPath */.VA, "fedBuilding.svg"),
              alt: "An extra $".concat(bonusAmount, " for joining")
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
              children: ["Your funds are FDIC insured up to $250,000 through our bank partners", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
                children: "2"
              })]
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* Button */.zx, {
          onClick: function onClick() {
            return activateP2pEnrollmentAndNavigate(trackCtaButtonClick);
          },
          children: ["Join Chime to get another $", bonusAmount]
        })
      })]
    })]
  });
};

function AnimatedFooter(_ref2) {
  var bank = _ref2.bank,
      animationControls = _ref2.animationControls;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(motion_minimal.m.div, {
    initial: 'hidden',
    animate: animationControls,
    variants: contentAnimations,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Pay_ConfirmationTermsAndConditionsValueProps, {
      bank: bank
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* Footer */.$_, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* CopyrightText */.mr, {})
    })]
  });
}

var MoneyIconLayout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(PayAnyoneConfirmation_templateObject || (PayAnyoneConfirmation_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"])));
var ButtonLayout = styled_components_browser_esm/* default.div */.ZP.div(PayAnyoneConfirmation_templateObject2 || (PayAnyoneConfirmation_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), media/* default.tablet */.Z.tablet(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 2rem;\n  "]))));
var ContentLayout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  margin: 1.5rem 0;\n"])));
var TitleLayout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 2rem 0;\n  text-align: center;\n"])));
var Separator = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 0;\n  width: 112px;\n  border-top: solid 1px ", ";\n  margin: 0 auto;\n"])), system/* colors.lightGrey */.O9.lightGrey);
var ValuePropsLayout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 1.5rem;\n"])));
var ListBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n"])));
var ValuePropsTitle = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n"])));
/* harmony default export */ var Pay_PayAnyoneConfirmation = (PayAnyoneConfirmation);
// EXTERNAL MODULE: ./src/components/SubPages/Confirmation/useCreateConfirmationPageHook.tsx
var useCreateConfirmationPageHook = __webpack_require__(72736);
// EXTERNAL MODULE: ./src/utils/segment/trackingEvents.ts
var trackingEvents = __webpack_require__(79233);
;// CONCATENATED MODULE: ./src/components/SubPages/Confirmation/Request/useReceiveFromAnyoneConfirmationPage.tsx







function useReceiveFromAnyoneConfirmationPage() {
  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId;

  var _useP2PEnrollmentFlow = (0,useP2PEnrollmentFlow/* default */.Z)(false //Claim with Chime is not enabled in Receive From Anyone yet
  ),
      activateP2pEnrollmentAndNavigate = _useP2PEnrollmentFlow.activateP2pEnrollmentAndNavigate;

  var trackPageViewed = function trackPageViewed() {
    (0,trackingEvents/* trackReceiveFromAnyoneConfirmationInfoPageViewed */._H)(publicId, 'join chime');
  };

  var trackAndNavigateToEnrollment = function trackAndNavigateToEnrollment() {
    var trackJoinChimeCTATapped = function trackJoinChimeCTATapped() {
      return (0,trackingEvents/* trackCTATapped */.u)("P2P Request Payment", 'Join Chime', 'P2P Request Payment Confirmation Page', 'p2p_request_payment_confirmation_join_chime_button', publicId);
    };

    activateP2pEnrollmentAndNavigate(trackJoinChimeCTATapped);
  };

  var trackConfirmationAnimationViewed = (0,react.useCallback)(function () {
    (0,trackingEvents/* trackReceiveFromAnyoneConfirmationInfoPageViewed */._H)(publicId, 'you paid');
  }, [publicId]);

  var _useCreateConfirmatio = (0,useCreateConfirmationPageHook/* default */.Z)(trackPageViewed, trackAndNavigateToEnrollment),
      trackCtaButtonClick = _useCreateConfirmatio.trackCtaButtonClick;

  return {
    onJoinChimeClick: trackCtaButtonClick,
    trackConfirmationAnimationViewed: trackConfirmationAnimationViewed
  };
}

/* harmony default export */ var Request_useReceiveFromAnyoneConfirmationPage = (useReceiveFromAnyoneConfirmationPage);
;// CONCATENATED MODULE: ./src/components/SubPages/Confirmation/Request/ReceiveFromAnyoneConfirmation.tsx




var ReceiveFromAnyoneConfirmation_templateObject, ReceiveFromAnyoneConfirmation_templateObject2, ReceiveFromAnyoneConfirmation_templateObject3, ReceiveFromAnyoneConfirmation_templateObject4, ReceiveFromAnyoneConfirmation_templateObject5, ReceiveFromAnyoneConfirmation_templateObject6, ReceiveFromAnyoneConfirmation_templateObject7, ReceiveFromAnyoneConfirmation_templateObject8, ReceiveFromAnyoneConfirmation_templateObject9, _templateObject10, _templateObject11;




















var ReceiveFromAnyoneConfirmation = function ReceiveFromAnyoneConfirmation() {
  var containerRef = (0,react.useRef)(null);

  var _useUserContext = (0,useUserContext/* useUserContext */.S)(),
      _useUserContext2 = (0,slicedToArray/* default */.Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var amount = userData.amount,
      name = userData.name;

  var _useReceiveFromAnyone = Request_useReceiveFromAnyoneConfirmationPage(),
      onJoinChimeClick = _useReceiveFromAnyone.onJoinChimeClick,
      trackConfirmationAnimationViewed = _useReceiveFromAnyone.trackConfirmationAnimationViewed;

  var animationControls = (0,use_animation/* useAnimation */._)();
  (0,react.useEffect)(function () {
    var startAnimation = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                trackConfirmationAnimationViewed();
                _context.next = 3;
                return animationControls.start('showTitle');

              case 3:
                _context.next = 5;
                return animationControls.start('showIcon');

              case 5:
                _context.next = 7;
                return animationControls.start('contentSlide');

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function startAnimation() {
        return _ref.apply(this, arguments);
      };
    }();

    startAnimation();
  }, [animationControls, trackConfirmationAnimationViewed]);

  var _useIntersect = (0,useIntersect/* useIntersect */.U)({
    root: null,
    rootMargin: '0px',
    threshold: [0.5, 0.9]
  }),
      _useIntersect2 = (0,slicedToArray/* default */.Z)(_useIntersect, 2),
      setNode = _useIntersect2[0],
      entry = _useIntersect2[1];

  (0,react.useEffect)(function () {
    setNode(containerRef.current);
  }, [setNode]);
  (0,useValuePropsSegmentEvents/* useValuePropsSegmentEvents */.h)(entry, 'RFA Confirmation Page');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.ZP, {
    header: /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* CenteredHeader */.R, {}),
    footer: /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneConfirmation_AnimatedFooter, {
      animationControls: animationControls
    }),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneConfirmation_MoneyIconLayout, {
      initial: 'hidden',
      animate: animationControls,
      variants: iconAnimations,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* MoneyBox */.j6, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneConfirmation_TitleLayout, {
      initial: 'hidden',
      animate: animationControls,
      variants: titleAnimations,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Title */.Dx, {
        size: 'small',
        children: ["You paid ", name, " $", amount, "!"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(motion_minimal.m.div, {
      initial: 'hidden',
      animate: animationControls,
      variants: contentAnimations,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneConfirmation_ValuePropsLayout, {
        ref: containerRef,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneConfirmation_Separator, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ListBoxTitleLayout, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
            size: 'standard',
            bold: true,
            children: ["Join ", name, " on Chime"]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ListBoxLayout, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneConfirmation_ListBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLayout, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ThreePeopleIcon */.vL, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
              children: "Send and receive money fee-free, no matter what bank account they use"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneConfirmation_ListBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLayout, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* ScissorFeesIcon */.GC, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Text */.xv, {
              children: "No cash-out fees for you or anyone"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ReceiveFromAnyoneConfirmation_ListBox, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconLayout, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* PadLockIcon */.e0, {})
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* Text */.xv, {
              children: ["Your funds are FDIC-insured up to $250,000 through our bank partners", /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
                children: "1"
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReceiveFromAnyoneConfirmation_ButtonLayout, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* Button */.zx, {
          onClick: onJoinChimeClick,
          children: "Join Chime"
        })
      })]
    })]
  });
};

function ReceiveFromAnyoneConfirmation_AnimatedFooter(_ref2) {
  var animationControls = _ref2.animationControls;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(motion_minimal.m.div, {
    initial: 'hidden',
    animate: animationControls,
    variants: contentAnimations,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TermsAndConditionsLayout, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* TextBlock */.al, {
        size: 'small',
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* Superscript */.$2, {
          children: "1"
        }), " Deposits in Chime accounts are FDIC insured through The Bancorp Bank or Stride Bank; Members FDIC."]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* Footer */.$_, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* CopyrightText */.mr, {})
    })]
  });
}

var ReceiveFromAnyoneConfirmation_MoneyIconLayout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(ReceiveFromAnyoneConfirmation_templateObject || (ReceiveFromAnyoneConfirmation_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"])));
var ReceiveFromAnyoneConfirmation_ButtonLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneConfirmation_templateObject2 || (ReceiveFromAnyoneConfirmation_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", ";\n"])), media/* default.tablet */.Z.tablet(ReceiveFromAnyoneConfirmation_templateObject3 || (ReceiveFromAnyoneConfirmation_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin-bottom: 2rem;\n  "]))));
var ReceiveFromAnyoneConfirmation_TitleLayout = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div)(ReceiveFromAnyoneConfirmation_templateObject4 || (ReceiveFromAnyoneConfirmation_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 2rem 0;\n  text-align: center;\n"])));
var TermsAndConditionsLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneConfirmation_templateObject5 || (ReceiveFromAnyoneConfirmation_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 1.5rem;\n  text-align: left;\n"])));
var ReceiveFromAnyoneConfirmation_ValuePropsLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneConfirmation_templateObject6 || (ReceiveFromAnyoneConfirmation_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 2rem 0;\n"])));
var ReceiveFromAnyoneConfirmation_Separator = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneConfirmation_templateObject7 || (ReceiveFromAnyoneConfirmation_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 0;\n  width: 112px;\n  border-top: solid 1px ", ";\n  margin: 0 auto;\n"])), system/* colors.lightGrey */.O9.lightGrey);
var ListBoxTitleLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneConfirmation_templateObject8 || (ReceiveFromAnyoneConfirmation_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-align: center;\n  margin: 2rem 0 1.5rem 0;\n"])));
var ListBoxLayout = styled_components_browser_esm/* default.div */.ZP.div(ReceiveFromAnyoneConfirmation_templateObject9 || (ReceiveFromAnyoneConfirmation_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-row-gap: 1.5rem;\n"])));
var ReceiveFromAnyoneConfirmation_ListBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-column-gap: 1.5rem;\n  grid-template-columns: min-content 2fr;\n  align-items: center;\n"])));
var IconLayout = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: 80px;\n  width: 80px;\n  grid-column-start: 1;\n"])));
/* harmony default export */ var Request_ReceiveFromAnyoneConfirmation = (ReceiveFromAnyoneConfirmation);
;// CONCATENATED MODULE: ./src/components/SubPages/Confirmation/index.tsx



/***/ }),

/***/ 72736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var hooks_useUserContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36220);




function useCreateConfirmationPageHook(trackPageViewed, trackCtaClick) {
  var _useUserContext = (0,hooks_useUserContext__WEBPACK_IMPORTED_MODULE_1__/* .useUserContext */ .S)(),
      _useUserContext2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    trackPageViewed();
  }, [publicId, trackPageViewed]);

  var trackCtaButtonClick = function trackCtaButtonClick() {
    trackCtaClick();
  };

  return {
    trackCtaButtonClick: trackCtaButtonClick
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useCreateConfirmationPageHook);

/***/ }),

/***/ 44143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50152);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var PayFAQText = function PayFAQText() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StrongTextSpaced */ .SH, {
      children: "What are instant transfers, and are they really free?"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Instant transfers allow you to transfer funds that were sent by a Chime member directly to any U.S. bank issued debit card - all for free."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Once the Friend Transfer has been successfully claimed, the funds are transferred to the bank account associated with the debit card information you have provided."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Funds availability may depend on your receiving bank. The funds transfer transaction may appear in processing or pending status and your available balance may not update until the transaction has been fully processed by your receiving bank. This may take up to 30 minutes depending on your bank."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Instant transfers can be used to claim Friend Transfers 24 hours a day, 365 days a year regardless of holiday or weekend schedules. Please note that claiming Friend Transfers may be affected by circumstances beyond our control (such as fire, flood, power failure, strike, labor dispute, critical service provider failure, computer breakdown, telephone line disruption, government or regulatory action, or a natural disaster), despite reasonable precautions that we have taken."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Additionally, Friend Transfers are reviewed and could be declined, delayed, or blocked if the transfer could result in fraud or another form of financial harm. We may request you provide additional information to verify your identity."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "We may limit how many Friend Transfers you can claim and the amount of funds you can claim in a single day, week, or month."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Funds that are sent to you by a Chime member are available to be claimed for 14 days from the time the Friend Transfer is initiated. After 14 days, the transaction will expire, and the funds will automatically be transferred back to the sending Chime Member."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StrongTextSpaced */ .SH, {
      children: "How do I know if I have an eligible bank account or debit card?"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Instant transfers only work with U.S. bank issued debit cards. Credit cards, pre-paid cards, and debit cards issued by foreign banks will not be eligible to use with this feature."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StrongTextSpaced */ .SH, {
      children: "Why did I get an error when I tried to instantly transfer funds to my bank account?"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "Instant transfers can be reviewed and declined for a variety of reasons, including Chime\u2019s automated internal security measures. Before attempting an instant transfer, please make sure you\u2019re using a card that is registered in your own name. Likewise, here is are some common reasons why you might be receiving an error message:"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      as: "span",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ol", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Did I enter my debit card information correctly?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Did my debit card expire?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Does the ZIP code I entered match the ZIP code on file with my debit card?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Did I enter my credit card information?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Did I enter my pre-paid information? "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Did I enter my foreign bank account issued debit card information?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Has it been more than 14 days since the payment was sent?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Have I already claimed these funds?"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
          children: "Would claiming these funds place me over the non-member recipient dollar limit?"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "If you continue to receive an error message after considering the above, this means that the instant transfer feature you can use to claim your Friend Transfer is not currently available. This might happen even if you\u2019ve used a debit card for instant transfer successfully in the past."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StrongTextSpaced */ .SH, {
      children: "How do I check on the status of my instant transfer?"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "After you have successfully provided a valid name, email address, and U.S. debit card information for the transfer, you will receive a confirmation on the web page indicating whether the transfer was successful. You will also receive an email confirmation of the successful transfer as well."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(chime_ui_components_Typography__WEBPACK_IMPORTED_MODULE_0__/* .StandardTextSpaced */ .gy, {
      children: "You can also check the status of the transaction from your bank account. You can reach out to your bank directly if your transfer is not showing on your bank statement. When you contact them, it\u2019s important to explain that the money will appear as an original credit transaction (OCT) or a real-time payment, not a missing ACH/direct deposit."
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PayFAQText);

/***/ }),

/***/ 42029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useBonusAmount; }
/* harmony export */ });
/* unused harmony export DEFAULT_BONUS_AMOUNT */
var DEFAULT_BONUS_AMOUNT = 15;
var useBonusAmount = function useBonusAmount() {
  var bonusAmount = DEFAULT_BONUS_AMOUNT;
  return {
    bonusAmount: bonusAmount
  };
};

/***/ }),

/***/ 62463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useIntersect; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var useIntersect = function useIntersect(_ref) {
  var _ref$root = _ref.root,
      root = _ref$root === void 0 ? null : _ref$root,
      rootMargin = _ref.rootMargin,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? [0] : _ref$threshold;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    isIntersecting: false
  }),
      entry = _useState[0],
      updateEntry = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      node = _useState2[0],
      setNode = _useState2[1];

  var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var callbackFunction = function callbackFunction(entries) {
    var _entries = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(entries, 1),
        entry = _entries[0];

    if (entry.isIntersecting) {
      updateEntry(entry);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (observer.current) observer.current.disconnect();

    if ('IntersectionObserver' in window) {
      observer.current = new IntersectionObserver(callbackFunction, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold
      });
      if (node) observer.current.observe(node);
    }

    return function () {
      if (observer.current) observer.current.disconnect();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [node, root, rootMargin, "".concat(threshold)]);
  return [setNode, entry];
};

/***/ }),

/***/ 56785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20381);
/* harmony import */ var hooks_useBonusAmount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42029);
/* harmony import */ var hooks_useTransactionType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38598);
/* harmony import */ var utils_setTrailingZeros__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44925);






function useP2PEnrollmentFlow(isClaimWithChimeEnabled, amount) {
  var _useBonusAmount = (0,hooks_useBonusAmount__WEBPACK_IMPORTED_MODULE_3__/* .useBonusAmount */ .O)(),
      bonusAmount = _useBonusAmount.bonusAmount;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var token = router.query.token;

  var _useTransactionType = (0,hooks_useTransactionType__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      claimType = _useTransactionType.claimType;

  var generateEnrollmentUrl = function generateEnrollmentUrl() {
    var source = claimType === types__WEBPACK_IMPORTED_MODULE_1__/* .ClaimFlowType.receive */ .Tz.receive ? 'receive_from_anyone' : 'pay_anyone_v2';
    var ad = claimType === types__WEBPACK_IMPORTED_MODULE_1__/* .ClaimFlowType.receive */ .Tz.receive ? 'ch_rfa' : 'ch_pf';
    var idKey = claimType === types__WEBPACK_IMPORTED_MODULE_1__/* .ClaimFlowType.receive */ .Tz.receive ? 'ch_rfaid' : 'ch_pfid';
    var baseUrl = "".concat("", "/enroll/?ad=").concat(ad, "&").concat(idKey, "=").concat(token, "&pf_token=").concat(token, "&src=").concat(source);
    var enrollmentQSPs = "&pf_p2p=true";
    if (isClaimWithChimeEnabled) enrollmentQSPs = "".concat(enrollmentQSPs, "&pai_amount=").concat((0,utils_setTrailingZeros__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(amount || '0'), "&pai_bonus=").concat(bonusAmount);
    return "".concat(baseUrl).concat(enrollmentQSPs);
  };

  var activateP2pEnrollmentAndNavigate = function activateP2pEnrollmentAndNavigate(callback) {
    var enrollmentUrl = generateEnrollmentUrl();

    if (callback) {
      callback();
    }

    window.location.replace(enrollmentUrl);
  };

  return {
    activateP2pEnrollmentAndNavigate: activateP2pEnrollmentAndNavigate
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useP2PEnrollmentFlow);

/***/ }),

/***/ 38598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20381);



function useTransactionType() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var requestFlow = {
    transactionTypeText: 'request',
    claimType: types__WEBPACK_IMPORTED_MODULE_1__/* .ClaimFlowType.receive */ .Tz.receive
  };
  var payFlow = {
    transactionTypeText: 'payment',
    claimType: types__WEBPACK_IMPORTED_MODULE_1__/* .ClaimFlowType.pay */ .Tz.pay
  };
  var transactionType = router.route.includes('request') ? requestFlow : payFlow;
  return transactionType;
}

/* harmony default export */ __webpack_exports__["Z"] = (useTransactionType);

/***/ }),

/***/ 9502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useValuePropsSegmentEvents; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var hooks_useUserContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36220);
/* harmony import */ var utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79233);




var useValuePropsSegmentEvents = function useValuePropsSegmentEvents(entry, pageLocation) {
  var _useUserContext = (0,hooks_useUserContext__WEBPACK_IMPORTED_MODULE_1__/* .useUserContext */ .S)(),
      _useUserContext2 = (0,_home_circleci_project_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useUserContext, 1),
      userData = _useUserContext2[0];

  var publicId = userData.publicId;
  var seenValuePropOnce = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    half: false,
    full: false
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var isIntersecting = entry.isIntersecting,
        intersectionRatio = entry.intersectionRatio;

    if (isIntersecting) {
      var _ref = seenValuePropOnce.current || {},
          half = _ref.half,
          full = _ref.full;

      if (intersectionRatio >= 0.5 && intersectionRatio <= 0.59 && !half) {
        seenValuePropOnce.current.half = true;
        (0,utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .trackValuePropsViewed */ .QZ)(pageLocation, publicId, 'Half');
      }

      if (intersectionRatio >= 0.9 && intersectionRatio <= 1.0 && !full) {
        seenValuePropOnce.current.full = true;
        (0,utils_segment_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .trackValuePropsViewed */ .QZ)(pageLocation, publicId, 'Full');
      }
    }
  }, [entry, publicId, pageLocation]);
};

/***/ })

}]);